module.exports = __webpack_public_path__ + "img/3_3.7ea920a5.jpg";